// Données de l'accueil : clés « today-… » (et les réunions à venir), relues après chaque enregistrement et au
// retour sur l'onglet (AppProviders).
export const isTodayKey = (key: readonly unknown[]) =>
  typeof key[0] === "string" &&
  (key[0].startsWith("today-") || key[0] === "upcoming-meetings");
